import { matchPath } from 'react-router-dom';

const ACCOUNT_PATH_PREFIXES = [
  '/account',
  '/account-settings',
  '/users',
  '/my-products',
];

/** Paths served by the private `/` catch-all in paths/account.js */
export const isKnownAccountPath = (pathname) =>
  pathname === '/' ||
  ACCOUNT_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

/**
 * Whether `pathname` matches a real app route (not the private catch-all
 * swallowing unknown paths like `/trial-signup`).
 */
export const isKnownRoute = (pathname, routes) => {
  const route = routes.find((entry) =>
    matchPath(pathname, { path: entry.path, exact: entry.exact })
  );

  if (!route) {
    return false;
  }

  if (route.path === '/' && route.exact === false) {
    return isKnownAccountPath(pathname);
  }

  return true;
};
